export default __webpack_public_path__ + "static/media/mobile2.641dcf50.webp";